import { render, staticRenderFns } from "./show.vue?vue&type=template&id=a5ccb46a&"
import script from "./show.vue?vue&type=script&lang=js&"
export * from "./show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5ccb46a')) {
      api.createRecord('a5ccb46a', component.options)
    } else {
      api.reload('a5ccb46a', component.options)
    }
    module.hot.accept("./show.vue?vue&type=template&id=a5ccb46a&", function () {
      api.rerender('a5ccb46a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/captain_working_summaries/show.vue"
export default component.exports